import { render } from "./physiotherapy_imaging.vue?vue&type=template&id=e1c34bcc&scoped=true"
import script from "./physiotherapy_imaging.vue?vue&type=script&lang=js"
export * from "./physiotherapy_imaging.vue?vue&type=script&lang=js"

import "./physiotherapy_imaging.vue?vue&type=style&index=0&id=e1c34bcc&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1c34bcc"]])

export default __exports__